<template>
    <el-dialog
            title="提示信息"
            :visible.sync="DailogVisible"
            :before-close="handleCloseA"
            width="527px"
            class="dialog-tips"
            border>
        <el-form  label-width="40px">
            <el-row type="flex" justify="space-between" :key="AuditInfo.realName">
                <el-col :span="24">
                    <el-form-item  label="企业名称" label-width="100px">
                        <el-input style="width: 100%;" disabled v-model="AuditInfo.realName"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="space-between"  :key="AuditInfo.realName">
                <el-col :span="24">
                    <el-form-item  label="企业应付总额" label-width="100px"><el-input style="width: 100%;" disabled v-model="AuditInfo.money"></el-input></el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="备注" label-width="100px">
                <el-input type="textarea" :autosize="{ minRows: 2}" placeholder="请输入备注" v-model="reason"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="batchAuditTask('pass')">通过</el-button>
			<el-button @click="batchAuditTask('')">不通过</el-button>
			</span>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                reason:"",
            }
        },
        props: ['DailogVisible','AuditInfo'],
        components: {},
        watch: {},
        computed: {},
        methods: {
//            关闭弹框
            handleCloseA(){
                this.$emit( 'handleCloseA',false)
            },
//            审核
            batchAuditTask(val){
                this.$confirm(this.$t('prompt.info', { 'handle': '审核任务'}), this.$t('prompt.title'), {
                    confirmButtonText: this.$t('confirm'),
                    cancelButtonText: this.$t('cancel'),
                    type: 'warning'
                }).then(()=>{
                    this.handleCloseA()
                    this.$emit('handleAudit',{state:val,flag:false,id:this.AuditInfo.id,reason:this.reason})
                }).catch(()=>{})
            }
        },
    }
</script>
<style lang="scss">
</style>